import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import "../../../index.css";
import SystemUpdateAlt from "@mui/icons-material/SystemUpdateAlt";
import Tune from "@mui/icons-material/Tune";
import MarkEmailUnreadOutlined from "@mui/icons-material/MarkEmailUnreadOutlined";

function OtherSetting() {
  return (
    <div className=" p-2">
      <span className="title">Other Setting</span>
      <div className="grid-container mt-4 text-center">
        <div className="grid-item">
          <div className="setting1">
            <div className="setting-link mt-1 d-flex flex-column">
              <Link
                to="/other-setting/setting-preferences"
                className="setting-layout text-decoration-none"
              >
                <Tune className="icon-setting mb-3" />
                <span
                  className="text-decoration-none"
                  style={{ color: "#505050" }}
                >
                  Preferences
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div className=" grid-item">
          <div className="setting1">
            <div className="setting-link mt-1 d-flex flex-column">
              <Link
                to="/other-setting/notification-preferences"
                className="setting-layout text-decoration-none"
              >
                <MarkEmailUnreadOutlined className="icon-setting mb-3" />
                <span
                  className="text-decoration-none"
                  style={{ color: "#505050" }}
                >
                  Email Notification
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div className=" grid-item">
          <div className="setting1">
            <div className="setting-link mt-1 d-flex flex-column">
              <Link to="" className="text-decoration-none setting-layout">
                <SystemUpdateAlt className="icon-setting mb-3" />
                <span
                  className="text-decoration-none"
                  style={{ color: "#505050" }}
                >
                  Import/Export Data
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OtherSetting;
